import { determineIfMultiSelectable } from './addSelectFunctionalityToDrawable'
import { setActiveDrawable } from '../../../../actions/drawable'
import { PAPER_ELEMENT_TYPE } from '../../../../shared/constants/drawable-types'
import store from '../../../../stores'
import { updateSelectedPaperId } from '../../../slices/2D'
import { clearActiveForm } from '../../../slices/forms'
import { setActiveToolObjectId, updateToolObjectCoordinates } from '../../../slices/tools'
import { IMUP2DCoordinatesToUpdate } from '../../../types'
import { FloorLevelBreaklineTool } from '../../toolBoxes/2D'

function saveToolObject(): (coordinatesToUpdate: IMUP2DCoordinatesToUpdate) => void {
    return function saveToolObject(this: paper.Path, coordinatesToUpdate) {
        store.dispatch(updateToolObjectCoordinates(coordinatesToUpdate))
    }
}

function selectToolObject(): () => void {
    return function selectDrawable(this: paper.Path) {
        if (this.data?.toolName && this.data.toolName !== FloorLevelBreaklineTool.NAME) {
            store.dispatch(clearActiveForm())
        }

        store.dispatch(setActiveToolObjectId(this.data.toolObject.id))
        store.dispatch(updateSelectedPaperId(this.id))
    }
}

function deselectToolObject(): () => void {
    return function deselectDrawable(this: paper.Path) {
        store.dispatch(clearActiveForm())

        store.dispatch(setActiveToolObjectId(null))
        store.dispatch(updateSelectedPaperId(null))

        store.dispatch(setActiveDrawable(null, 0))
    }
}

export default function addSelectFunctionalityToToolObjects(item: paper.PathItem): void {
    item.data.type = PAPER_ELEMENT_TYPE.TOOL_OBJECT
    item.data.isMultiSelectable = determineIfMultiSelectable(item)
    item.data.onSave = saveToolObject().bind(item)
    item.data.onSelect = selectToolObject().bind(item)
    item.data.onDeselect = deselectToolObject().bind(item)
}
